module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "resources-page"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.resources.length === 0) ? _c('div', {
    key: "still-loading"
  }, [_c('loader-large')], 1) : _c('div', {
    key: "done-loading"
  }, [_vm._l((_vm.resources), function(resource) {
    return (resource.selected) ? _c('ul', {
      attrs: {
        "id": "resource-category-switcher"
      }
    }, _vm._l((resource.sections), function(section) {
      return _c('li', {
        class: {
          selected: section.selected
        }
      }, [(!section.selected) ? _c('router-link', {
        attrs: {
          "to": '/Resources/' + resource.id + '/' + section.id,
          "title": section.text
        }
      }, [_c('i', {
        class: 'fa ' + section.icon
      }), _vm._v(" " + _vm._s(section.text) + "\n                    ")]) : _c('span', [_c('i', {
        class: 'fa ' + section.icon
      }), _vm._v(" " + _vm._s(section.text))])], 1)
    })) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.resources), function(resource) {
    return (resource.selected) ? _c('div', {
      attrs: {
        "id": "resource-list"
      }
    }, _vm._l((resource.sections), function(section) {
      return (section.selected) ? _c('ul', {
        staticClass: "resource-items"
      }, _vm._l((section.resourceItems), function(resourceItem) {
        return (resourceItem.allVotes > -2) ? _c('li', {
          staticClass: "resource-item",
          attrs: {
            "id": 'resource-item-' + resourceItem.id
          }
        }, [_c('h4', [_c('a', {
          attrs: {
            "href": resourceItem.url,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(resourceItem.text))])]), _vm._v(" "), _c('voting-widget', {
          attrs: {
            "parent-type": "resource",
            "parent-id": resourceItem.id,
            "initial-points": resourceItem.allVotes
          }
        })], 1) : _vm._e()
      })) : _vm._e()
    })) : _vm._e()
  }), _vm._v(" "), (_vm.showSubmitResourceForm) ? _c('div', {
    attrs: {
      "id": "submit-new-resource"
    }
  }, [_c('h2', [_vm._v("Submit a New Resource")]), _vm._v(" "), (!_vm.$store.state.resourcesPageModel.submittedNewResource) ? _c('form', [_c('div', {
    staticClass: "container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addResourceWebsiteName),
      expression: "addResourceWebsiteName"
    }],
    class: {
      invalid: _vm.addResourceWebsiteNameInvalid
    },
    attrs: {
      "type": "text",
      "id": "new-resource-name",
      "placeholder": "Website Name"
    },
    domProps: {
      "value": (_vm.addResourceWebsiteName)
    },
    on: {
      "keyup": function($event) {
        _vm.addResourceWebsiteNameInvalid = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addResourceWebsiteName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addResourceWebsiteUrl),
      expression: "addResourceWebsiteUrl"
    }],
    class: {
      invalid: _vm.addResourceWebsiteUrlInvalid
    },
    attrs: {
      "type": "text",
      "id": "new-resource-url",
      "placeholder": "Website URL"
    },
    domProps: {
      "value": (_vm.addResourceWebsiteUrl)
    },
    on: {
      "keyup": function($event) {
        _vm.addResourceWebsiteUrlInvalid = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addResourceWebsiteUrl = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addResourceCategory),
      expression: "addResourceCategory"
    }],
    attrs: {
      "id": "new-resource-category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addResourceCategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "assets"
    }
  }, [_vm._v("Assets")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "devtools"
    }
  }, [_vm._v("Dev Tools")])]), _vm._v(" "), (_vm.addResourceCategory === 'assets') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addResourceSectionAssets),
      expression: "addResourceSectionAssets"
    }],
    attrs: {
      "id": "new-resource-section-assets"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addResourceSectionAssets = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "graphics"
    }
  }, [_vm._v("Graphics")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fonts"
    }
  }, [_vm._v("Fonts")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sfx"
    }
  }, [_vm._v("Sound Effects")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "music"
    }
  }, [_vm._v("Music")])]) : _vm._e(), _vm._v(" "), (_vm.addResourceCategory === 'devtools') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addResourceSectionDevtools),
      expression: "addResourceSectionDevtools"
    }],
    attrs: {
      "id": "new-resource-section-devtools"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addResourceSectionDevtools = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "collaboration"
    }
  }, [_vm._v("Collaboration")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "engines"
    }
  }, [_vm._v("Game Engines")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "programming"
    }
  }, [_vm._v("Programming")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "graphics"
    }
  }, [_vm._v("Graphics")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "audio"
    }
  }, [_vm._v("Audio")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "video"
    }
  }, [_vm._v("Video")])]) : _vm._e()]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Submit",
      "id": "submit-form"
    },
    on: {
      "click": _vm.addResource
    }
  })]) : _c('div', [_c('p', [_vm._v("Thank you for submitting a new Resource. "), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$store.state.resourcesPageModel.submittedNewResource = false
      }
    }
  }, [_vm._v("Submit Another")]), _vm._v("?")])])]) : _vm._e()], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-470ef2cd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Resources/ResourcesPage.vue
// module id = 864
// module chunks = 2